import React, {Component} from 'react';

/**
 * Displays a notification in the card-present payment method section when
 * a customization of PaymentMethodCardPresentFields hasn't been configured
 * for the TLA.
 */
class PaymentMethodCardPresentFields extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {config, paymentMethod, state} = this.props,
            {messages} = config;
        return (
            <React.Fragment>
                <div className="row col-8">
                    <div className="row">
                        <div className="col-12">
                            <span>A card-present provider must be configured.</span>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}


export default PaymentMethodCardPresentFields
